import { Status, STATUS_SIZE_16, STATUS_SIZE_20 } from '../../Status'
import { Container } from '../Container'

import * as styles from './Statuses.module.css'

function Statuses() {
  const successfulTextColor = 'var(--color-success)'
  const inProgressTextColor = 'var(--color-in-progress)'
  const importedTextColor = 'var(--color-info)'
  const failedTextColor = 'var(--color-error)'
  const declinedTextColor = 'var(--color-declined)'
  const awaitingTextColor = 'var(--color-info)'
  const newFileTextColor = 'var(--secondary-text-color)'
  const canceledBgColor = 'var(--color-error)'

  return (
    <>
      <Container label='Status, success, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Successful'
          textColor={successfulTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Successful'
          textColor={successfulTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Successful'
          textColor={successfulTextColor}
        />
      </Container>
      <Container label='Status, success, with long text, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Successful Successful Successful Successful Successful'
          textColor={successfulTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Successful Successful Successful Successful Successful'
          textColor={successfulTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Successful Successful Successful Successful Successful'
          textColor={successfulTextColor}
        />
      </Container>
      <Container label='Status, success, with close button, sizes - 24px, 20px'>
        <Status
          className={styles.rightMargin}
          text='Successful'
          textColor={successfulTextColor}
          onRemove={() => {}}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Successful'
          textColor={successfulTextColor}
          onRemove={() => {}}
        />
      </Container>
      <Container label='Status, success, with long text, with close button, sizes - 24px, 20px'>
        <Status
          className={styles.rightMargin}
          text='Successful Successful Successful Successful Successful'
          textColor={successfulTextColor}
          onRemove={() => {}}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Successful Successful Successful Successful Successful'
          textColor={successfulTextColor}
          onRemove={() => {}}
        />
      </Container>
      <Container label='Status, in progress, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='In progress'
          textColor={inProgressTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='In progress'
          textColor={inProgressTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='In progress'
          textColor={inProgressTextColor}
        />
      </Container>
      <Container label='Status, imported, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Imported'
          textColor={importedTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Imported'
          textColor={importedTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Imported'
          textColor={importedTextColor}
        />
      </Container>
      <Container label='Status, failed, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Failed'
          textColor={failedTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Failed'
          textColor={failedTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Failed'
          textColor={failedTextColor}
        />
      </Container>
      <Container label='Status, declined, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Declined'
          textColor={declinedTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Declined'
          textColor={declinedTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Declined'
          textColor={declinedTextColor}
        />
      </Container>
      <Container label='Status, awaiting, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='Awaiting'
          textColor={awaitingTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Awaiting'
          textColor={awaitingTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='Awaiting'
          textColor={awaitingTextColor}
        />
      </Container>
      <Container label='Status, new file, sizes - 24px, 20px, 16px'>
        <Status
          className={styles.rightMargin}
          text='New file'
          textColor={newFileTextColor}
        />
        <Status
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='New file'
          textColor={newFileTextColor}
        />
        <Status
          height={STATUS_SIZE_16}
          text='New file'
          textColor={newFileTextColor}
        />
      </Container>
      <Container label='Status, canceled, sizes - 24px, 20px, 16px'>
        <Status
          backgroundColor={canceledBgColor}
          className={styles.rightMargin}
          text='Canceled'
        />
        <Status
          backgroundColor={canceledBgColor}
          className={styles.rightMargin}
          height={STATUS_SIZE_20}
          text='Canceled'
        />
        <Status
          backgroundColor={canceledBgColor}
          height={STATUS_SIZE_16}
          text='Canceled'
        />
      </Container>
      <Container label='Status, canceled, with close button, sizes - 24px, 20px'>
        <Status
          backgroundColor={canceledBgColor}
          className={styles.rightMargin}
          text='Canceled'
          onRemove={() => {}}
        />
        <Status
          backgroundColor={canceledBgColor}
          height={STATUS_SIZE_20}
          text='Canceled'
          onRemove={() => {}}
        />
      </Container>
    </>
  )
}

export default Statuses
